import { inject, Pipe, PipeTransform } from '@angular/core';

import { ApContentService } from './content.service';

/**
 * @ngdoc pipe
 * @name ApContentPipe
 * @module ApContentModule
 * @description
 * Pipe which can be used to fetch content directly from your view when an directive cannot be used
 * (for example, for attribute values).
 *
 * The filter can be used in 2 ways.
 * 1. `{{'someKey' | apContent}}`, this takes the model as key and gets the matching content.
 * 2. `{{'someKey' | apContent:vm.model}}`, this will interpolate the matching content with the model.
 *
 * @param {(string|object)} key  The key.
 * @param {Map=} params Optional model used to interpolate the matching content or the key if
 * the model was provided as first argument.
 * @returns {string} The value.
 */
@Pipe({ name: 'apContent' })
export class ApContentPipe implements PipeTransform {
    private readonly contentService = inject(ApContentService);

    public transform(key: string, params?: { [key: string]: string }): string {
        return this.contentService.get(key, params);
    }
}
